// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getActiveAdsApi } from "../../Service/Api/ActiveAdsApi"
import { getActiveAdsList,getErrors } from "../Reducer/ActiveAdsReducer"


 

// Watchers
function* activeAdsSaga() {
	yield takeEvery("active_ads/getActiveAds", getAllActiveAds)
}

// Sagas
function* getAllActiveAds(action) {
   
	try {
		const getAdsData = yield call(getActiveAdsApi, action.payload)
		 
		if (getAdsData.request.status === 200) {
			yield put(getActiveAdsList(getAdsData))
	 
		} else {
          
			yield put(getErrors(true))
		}
	} catch (error) {
    
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(activeAdsSaga)])
}
